import axios from "axios";
import { Base_URL } from "../url";

export const fetchHouseBanks = async (id) => {
  try {
    const response = await axios.get(`${Base_URL}/HouseBank/GetAllHouseBanks/id?id=${id}`);
    return response.data;
  } catch (error) {
    throw error.response?.data || "Error fetching house banks!";
  }
};

export const downloadHouseBanksExcel = async () => {
  try {
    const response = await axios.post(
      `${Base_URL}/HouseBank/DownloadHouseBanksExcel`,
      null, // Empty body for POST request
      {
        responseType: 'blob',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
        }
      }
    );
    return response;
  } catch (error) {
    throw error.response?.data || "Error downloading house banks data!";
  }
};